import { Form, FormInstance, Input, Space } from "antd";
import { useMemo } from "react";
import MaskedInput from "react-text-mask";
import {
  WRONG_EIN_FORMAT,
  WRONG_SSN_FORMAT,
} from "../../../../../../../lib/constants";
import {
  SSN_INPUT_MASK_RULE,
  SSN_INPUT_RULE,
  EIN_INPUT_MASK_RULE,
  EIN_INPUT_RULE,
} from "../../../../../../../lib/validationRules";
import { TaxTypeSelect } from "./TaxTypeSelect";

type TaxIdInputProps = {
  form: FormInstance;
};

export const TaxIdInput = ({ form }: TaxIdInputProps) => {
  const taxIdType = Form.useWatch("taxIdType", form);

  const rules = useMemo(() => {
    return [
      {
        pattern: taxIdType === 1 ? SSN_INPUT_RULE : EIN_INPUT_RULE,
        validateTrigger: "onSubmit",
        message: taxIdType === 1 ? WRONG_SSN_FORMAT : WRONG_EIN_FORMAT,
      },
    ];
  }, [taxIdType]);

  const mask = useMemo(
    () => (taxIdType === 1 ? SSN_INPUT_MASK_RULE : EIN_INPUT_MASK_RULE),
    [taxIdType]
  );

  return (
    <Space.Compact className="w-100 ">
      <TaxTypeSelect form={form} />
      <Form.Item
        name="taxId"
        label="Tax Id"
        rules={rules}
        className="mb-0 tax-input"
      >
        <MaskedInput
          mask={mask}
          guide={false}
          showMask
          render={(ref, props) => {
            const value = form.getFieldValue(["taxId"]);

            return (
              <Input
                value={value}
                ref={(input: any) => ref(input && input.input)}
                {...props}
              />
            );
          }}
        />
      </Form.Item>
    </Space.Compact>
  );
};
